<template>
  <div class="content-container">
    <search-comp @onSearch="onSearch" @onReset="onReset">
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-row">
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Theo tháng</div>
                <div class="child-w-80">
                  <!-- v-model="searchParams.roomNumber" -->
                  <!-- @change="selectChange(selectValue)" -->
                  <!-- <el-select
                    v-model="searchParams.month"
                    @change="changeSelectMonth"
                  >
                    <el-option
                      v-for="(month, index) in monthList"
                      :key="index"
                      :value="month.value"
                      :label="month.name"
                    >
                    </el-option>
                  </el-select> -->
                  <el-date-picker
                    v-model="searchParams.month"
                    value-format="yyyy-MM-dd"
                    type="month"
                    placeholder="Vui lòng chọn tháng, năm"
                    @change="changeSelectMonth"
                  >
                  </el-date-picker>
                </div>
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Khách sạn</div>
                <div class="child-w-80">
                  <el-select
                    v-model="searchParams.hotelIdList"
                    multiple
                    collapse-tags
                  >
                    <el-option
                      v-for="(hotel, index) in hotelList"
                      :key="index"
                      :value="hotel.id"
                      :label="hotel.name"
                    >
                    </el-option>
                  </el-select>
                  <!-- <select v-model="searchParams.hotelId">
                    <option value=""></option>
                    <option
                      v-for="(hotel, index) in hotelList"
                      :key="index"
                      :value="hotel.id"
                      :label="hotel.name"
                    ></option>
                  </select> -->
                </div>
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Ngày</div>
                <div class="child-w-80">
                  <CalendarRange
                    v-model="datetimeRange"
                    style="display: block; width: 500px"
                    mode="date"
                    @input="setDateRange"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </search-comp>

    <div class="content-box">
      <div class="section-box outline">
        <div class="das-form-container">
          <div class="das-form-title-container justify-space-between">
            <div class="das-form-title">
              <span class="main-title">Báo cáo lịch sử</span>
            </div>
            <div class="button-containers-title">
              <InfoBtn @click="dialogFormVisible = true" />
              <el-dropdown trigger="click" @command="handleCommand">
                <button class="btn medium primary outline download-button">
                  <i class="el-icon-download"></i>
                </button>
                <el-dropdown-menu>
                  <el-dropdown-item command="pdf">Xuất PDF</el-dropdown-item>
                  <el-dropdown-item command="excel"
                    >Xuất Excel</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
              <!-- <button class="btn primary small">Xuất Excel</button> -->
            </div>
            <!-- <button class="btn medium primary outline">Thêm</button> -->
          </div>
          <hr />
          <div v-loading="loading" class="grid-scroll mt-10">
            <GridVx
              ref="agGrid"
              :columns="columns"
              :rows="rows"
              class="agGrid"
              row-selection="false"
              :header-height-setter="headerHeightSetter"
              :is-header-height-setter="true"
              :default-col-def="defaultColDef"
              :auto-size-cell="true"
              :auto-select-first-row="false"
            />
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      title="Chú thích"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      width="500px"
    >
      <div class="das-form-container">
        <div class="das-form-group">
          <ul class="annotate-container">
            <li>
              Ngày: Hiển thị ngày thuộc giai đoạn tìm kiếm, theo format:
              DDMMYYYY
            </li>
            <li>Tổng số phòng: Tổng số phòng vật lý của khách sạn</li>
            <li>Phòng bị chiếm: Tổng số phòng đã được gán cho đặt phòng</li>
            <li>Số lượng phòng sửa chữa OOO: số lượng phòng hỏng</li>
            <li>
              Phòng có thể bán: bằng tổng số phòng trừ Phòng sửa chữa trừ phòng
              bị chiếm
            </li>
            <li>
              Phòng miễn phí: Số lượng đặt phòng có tích là phòng miễn phí
            </li>
            <li>
              Doanh thu của những phòng bị chiếm là doanh thu chỉ tính tiền
              phòng của các phòng bị chiếm, tự động phân cách bằng dấu phẩy; là
              doanh thu thực (Đã trừ giảm giá)
            </li>
            <li>
              Doanh thu khi full: Doanh thu phòng của tổng số phòng trừ đi phòng
              OOO, tự động phân cách bằng dấu phẩy.
            </li>
            <li>
              Tỉ lệ doanh thu thực: Doanh thu thực của phòng bị chiếm/ Doanh thu
              khi full*100, lấy 2 số sau dấu phẩy
            </li>
            <li>
              Công suất: bằng phòng bị chiếm/tổng số phòng *100, lấy 2 số sau
              dấu phẩy
            </li>
          </ul>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button class="btn primary small" @click="dialogFormVisible = false">
            {{ $t('button.cancel') }}
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import CalendarRange from '@/components/CalendarSelect/CalendarRange.vue'
import InfoBtn from '../components/InfoBtn.vue'
import { getAllHotel } from '@/api/hotel'
import {
  getListHistory,
  getListHistoryExcel
} from '@/api/report_service/historyReport'
import { validate } from 'vee-validate'
import { downFile, getFileName } from '@/utils/file-handler'
export default {
  components: {
    CalendarRange,
    InfoBtn
  },
  data() {
    return {
      defaultColDef: {
        flex: 1,
        // resizable: true,
        // sortable: true,
        suppressMovable: true,
        // wrapText: true,
        headerComponentParams: {
          template:
            '<div class="ag-cell-label-container" role="presentation">' +
            '  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
            '  <div ref="eLabel" class="ag-header-cell-label" role="presentation">' +
            // '    <span ref="eSortOrder" class="ag-header-icon ag-sort-order"></span>' +
            // '    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon"></span>' +
            // '    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon"></span>' +
            // '    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon"></span>' +
            '    <span ref="eText" class="ag-header-cell-text" role="columnheader" style="white-space: normal;"></span>' +
            // '    <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>' +
            '  </div>' +
            '</div>'
        }
      },
      defaultDatetimeRange: {
        start: this.$moment().format('YYYY-MM-DD'),
        end: this.$moment().format('YYYY-MM-DD')
      },
      datetimeRange: {
        start: this.$moment().format('YYYY-MM-DD'),
        end: this.$moment().format('YYYY-MM-DD')
      },

      loading: false,
      monthList: [
        {
          value: 1,
          name: 'Tháng 1'
        },
        {
          value: 2,
          name: 'Tháng 2'
        },
        {
          value: 3,
          name: 'Tháng 3'
        },
        {
          value: 4,
          name: 'Tháng 4'
        },
        {
          value: 5,
          name: 'Tháng 5'
        },
        {
          value: 6,
          name: 'Tháng 6'
        },
        {
          value: 7,
          name: 'Tháng 7'
        },
        {
          value: 8,
          name: 'Tháng 8'
        },
        {
          value: 9,
          name: 'Tháng 9'
        },
        {
          value: 10,
          name: 'Tháng 10'
        },
        {
          value: 11,
          name: 'Tháng 11'
        },
        {
          value: 12,
          name: 'Tháng 12'
        }
      ],
      dialogFormVisible: false,
      hotelList: [],
      defaultSearchParams: {
        month: '',
        hotelIdList: [],
        dateFrom: this.$moment().format('YYYY-MM-DD'),
        dateTo: this.$moment().format('YYYY-MM-DD')
      },
      searchParams: {
        month: '',
        hotelIdList: [],
        dateFrom: this.$moment().format('YYYY-MM-DD'),
        dateTo: this.$moment().format('YYYY-MM-DD')
      },
      columns: [
        {
          headerName: this.$t('grid.column.date'),
          field: 'date',
          sortable: false,
          minWidth: 120,
          maxWidth: 120
        },
        {
          headerName: this.$t('grid.column.allRoom'),
          field: 'numOfRoom',

          sortable: false,
          minWidth: 120,
          maxWidth: 130
        },
        {
          headerName: this.$t('grid.column.occupiedRoom'),
          field: 'occupiedRoom',
          // cellRenderer: 'CellRenderTextInput',

          sortable: false,
          minWidth: 120,
          maxWidth: 130
        },
        {
          headerName: this.$t('grid.column.OOORoom'),
          field: 'oooOosRoom',
          // cellRenderer: 'CellRenderTextInput',
          sortable: false,

          minWidth: 120,
          maxWidth: 130
        },
        {
          headerName: this.$t('grid.column.canBuyRoom'),
          field: 'availableRoom',
          // cellRenderer: 'CellRenderTextInput',

          sortable: false,
          minWidth: 120,
          maxWidth: 130
        },
        {
          headerName: this.$t('grid.column.freeRoom'),
          field: 'focRoom',
          // cellRenderer: 'CellRenderTextInput',

          sortable: false,
          minWidth: 120,
          maxWidth: 130
        },

        {
          headerName: this.$t('grid.column.occupiedRevenue'),
          field: 'realRevenue',
          // cellRenderer: 'CellRenderTextInput',

          tooltipValueGetter: params => {
            if (params.value !== null && params.value !== undefined) {
              return Number(params.value).toLocaleString('en')
            }
            return null
          },
          // cellClass: "grid-cell-centered",
          valueFormatter: params => {
            if (params.value !== null && params.value !== undefined) {
              return Number(params.value).toLocaleString('en')
            }
            return null
          },
          sortable: false,
          minWidth: 150
        },
        {
          headerName: this.$t('grid.column.fullRevenue'),
          field: 'maxRevenue',
          tooltipValueGetter: params => {
            if (params.value !== null && params.value !== undefined) {
              return Number(params.value).toLocaleString('en')
            }
            return null
          },
          // cellClass: "grid-cell-centered",
          valueFormatter: params => {
            if (params.value !== null && params.value !== undefined) {
              return Number(params.value).toLocaleString('en')
            }
            return null
          },
          // cellRenderer: 'CellRenderTextInput',

          sortable: false,
          minWidth: 140
        },
        {
          headerName: this.$t('grid.column.percentRevenue'),
          field: 'ratioRevenue',
          // cellRenderer: 'CellRenderTextInput',

          sortable: false,
          minWidth: 140
        },
        {
          headerName: this.$t('grid.column.capacity'),
          field: 'wattage',
          // cellRenderer: 'CellRenderTextInput',

          sortable: false,
          minWidth: 140
        }
      ],
      rows: []
    }
  },
  created() {
    this.getListHotel()
  },
  mounted() {
    this.attachData()
  },
  methods: {
    handleCommand(cmmd) {
      // this.$message('click on item ' + cmmd)
      switch (cmmd) {
        case 'pdf':
          break
        case 'excel':
          this.downloadExcel()
          break
        default:
          this.$message('click on item ' + cmmd)
          break
      }
    },
    headerHeightGetter() {
      var columnHeaderTexts = [
        ...document.querySelectorAll('.ag-header-cell-text')
      ]
      var clientHeights = columnHeaderTexts.map(
        headerText => headerText.clientHeight
      )
      var tallestHeaderTextHeight = Math.max(...clientHeights)

      return tallestHeaderTextHeight
    },
    changeSelectMonth(value) {
      // console.log(value)
      this.searchParams.dateFrom = ''
      this.searchParams.dateTo = ''
      this.datetimeRange = { start: '', end: '' }
    },
    headerHeightSetter() {
      var padding = 30
      var height = this.headerHeightGetter() / 2 + padding
      this.$refs.agGrid.gridApi.setHeaderHeight(height)
      this.$refs.agGrid.gridApi.resetRowHeights()
    },
    setDateRange(range) {
      this.searchParams.month = null
      this.searchParams.dateFrom = range.start
      this.searchParams.dateTo = range.end
    },
    async getListHotel() {
      const data = await getAllHotel()
      this.hotelList = data.data
    },
    async attachData() {
      try {
        if (
          this.searchParams.dateFrom == '' &&
          this.searchParams.dateTo == '' &&
          this.searchParams.month == null
        ) {
          this.$message({
            type: 'error',
            message: this.$t('validation.required', {
              field: 'Thời gian đến và đi'
            })
          })
          return
        }
        this.loading = true
        let data = await getListHistory(this.searchParams)
        this.loading = false
        this.rows = data.data
      } catch (err) {
        this.$message({
          type: 'error',
          message: err
        })
      } finally {
        this.loading = false
      }
    },
    async downloadExcel() {
      try {
        if (
          this.searchParams.dateFrom == '' &&
          this.searchParams.dateTo == '' &&
          this.searchParams.month == null
        ) {
          this.$message({
            type: 'error',
            message: this.$t('validation.required', {
              field: 'Thời gian đến và đi'
            })
          })
          return
        }
        this.loading = true
        let data = await getListHistoryExcel(this.searchParams)
        const date = this.$moment().format('DD-MM-YYYY')
        downFile(data, 'bao_cao_lich_su_' + date + '.xlsx')
      } catch (err) {
        this.$message({
          type: 'error',
          message: err
        })
      } finally {
        this.loading = false
      }
    },
    onSearch() {
      this.attachData()
    },
    onReset() {
      this.searchParams = { ...this.defaultSearchParams }
      this.datetimeRange = { ...this.defaultDatetimeRange }
      this.attachData()
    }
  }
}
</script>

<style lang="scss"></style>
